import verificaSeParcelaAtrasada from '../../../../Utils/checkIfBillIsLate';
import { checkIsPossiblePayWithPix } from '../../../../Utils/PixFunctions';

const TEXT_PIX_TOOLTIP =
  'Se você fez o pagamento no Pix, o status será atualizado em alguns minutos.';

const handleArrayParcelasValue = (parcelas) => {
  const arrayParcelas = parcelas?.boletoAgrupado
    ? parcelas?.grupoExpandido?.membros
    : [parcelas];

  return arrayParcelas.map((p) => {
    return { parcela: p };
  });
};

const getNomeContrato = (idVenda) => {
  const contratos = JSON.parse(localStorage.getItem('contratosCliente'));
  return contratos?.find((contrato) => contrato.idVenda === idVenda)?.nome;
};

const isParcelaAtrasada = (arrayParcelas) => {
  return verificaSeParcelaAtrasada(arrayParcelas[0]?.parcela?.dataVencimento);
};
const isBoletoAtrasado = (arrayParcelas) => {
  return verificaSeParcelaAtrasada(arrayParcelas[0]?.parcela?.dtVencBoleto);
};

const handleProcessingMessage = (arrayParcelas) => {
  if (arrayParcelas[0]?.parcela?.temCartao) {
    return 'Processando seu pagamento por cartão';
  }

  if (arrayParcelas[0]?.parcela?.temPix) {
    return 'Processando seu pagamento por pix';
  }
};

const handleValueBoleto = (arrayParcelas) => {
  return arrayParcelas[0]?.parcela?.vlBoleto?.toFixed(2);
};

const isProcessandoPix = (arrayParcelas) => {
  return arrayParcelas[0]?.parcela?.temPix;
};

const isShowPix = (contratoSelecionado, parcelas) => {
  return (
    contratoSelecionado?.contrato?.pad_Cob_Pix > 0 &&
    parcelas.length === 1 &&
    checkIsPossiblePayWithPix(parcelas, contratoSelecionado)
  );
};

const isShowCard = (parcelas) => {
  return (
    parcelas[0].parcela?.elegivelCartaoAdimplente ||
    parcelas[0].parcela?.elegivelCartao
  );
};

const isShowPaymentMethods = (geracaoBoleto, isShowPix, isShowCard) => {
  return !geracaoBoleto && (isShowPix || isShowCard);
};

export {
  TEXT_PIX_TOOLTIP,
  handleArrayParcelasValue,
  getNomeContrato,
  isParcelaAtrasada,
  isBoletoAtrasado,
  handleProcessingMessage,
  handleValueBoleto,
  isProcessandoPix,
  isShowPix,
  isShowCard,
  isShowPaymentMethods,
};
